/**************************************************
 * Nombre:       Dialogo_Reserva
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, CircularProgress, Grid, IconButton, Typography} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import Tarjeta_Imagen_Reserva from "../Tarjetas/Tarjeta_Imagen_Reserva";
import foto1 from '../../Recursos/FOTOS/foto3.png'
import foto2 from '../../Recursos/FOTOS/foto6.png'
import foto3 from '../../Recursos/FOTOS/foto5.png'
import foto4 from '../../Recursos/FOTOS/foto7.png'
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Reserva_Datos from "../Formularios/Formulario_Reserva_Datos";
import {Close} from "@mui/icons-material";
import {theme} from "../../Tema";
import {useEffect, useRef, useState} from "react";
import {obtenerHabitacionesDisponibles} from "../../Modulo_Motor_Reservas/Funciones/obtenerHabitacionesDisponibles";
import defecto from '../../Recursos/defectohab.png'
import {adaptador_habitacion_mas_reserva} from "../Adaptadores/adaptador_habitacion_mas_reserva";
import {obtenerValorReserva} from "../../CodigoNegocio/obtenerValorReserva";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo.svg'
import {FECHACHECKIN, FECHACHECKOUT, ORIGENESRESERVAS} from "../../Modulo_Motor_Reservas/Constantes";
import {obtenerFechaEstandarCheckIn} from "../../Modulo_Motor_Reservas/Funciones/obtenerFechaEstandarCheckIn";
import {obtenerFechaEstandarCheckOut} from "../../Modulo_Motor_Reservas/Funciones/obtenerFechaEstandarCheckOut";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {enviarNotificacion} from "../../CodigoNegocio/Reservaciones/enviarNotificacionReserva";


const Dialogo_Reserva = ({datos, cerrar, realizado, open}) => {
    const refe = useRef()
    const {
        props,
        obtenerEntidad,
    } = useFormulario({valoresDefecto: {fechaCheckOut: new Date().getTime() + 1000 * 60 * 60 * 20}})
    const {Cargador, Avisos, iniciarCarga, terminar, nuevoAviso} = useCargador({logoRedondo: logo, funcionUno: cerrar})
    const [habitaciones, setHabitaciones] = useState([])
    const [seConsulto, setSeConsulto] = useState(false)

    const subirReserva = async () => {

        let indexHabitacion = refe.current.splide.index
        let seleccionada = habitaciones[indexHabitacion]
        console.log(seleccionada)


        let entidad = await obtenerEntidad()
        entidad = adaptador_habitacion_mas_reserva({reserva: entidad, habitacion: seleccionada})
        entidad.valor = obtenerValorReserva(entidad, seleccionada)
        entidad.valorSaldo = entidad.valor

        iniciarCarga('Subiendo datos')
        if (!entidad.id) {
            entidad.fecha = new Date().getTime()
        }

        if (!entidad.estado) {
            entidad.estado = 'Potencial'
        }

        if (!entidad.origen) {
            entidad.origen = ORIGENESRESERVAS[1]
        }

        entidad[FECHACHECKIN] = obtenerFechaEstandarCheckIn(entidad[FECHACHECKIN])
        entidad[FECHACHECKOUT] = obtenerFechaEstandarCheckOut(entidad[FECHACHECKOUT])

        let result = await guardarDoc('reservas', entidad)
        if (result.res) {
            enviarNotificacion(entidad)
            terminar({aviso: 'Reserva realizada, pronto nos comunicaremos contigo'})

        } else {
            terminar({aviso: 'Algo inesperado paso! datos no subidos', variante: 'error'})
        }
    }

    const ordenarHabitaciones = (habs) => {

        let arr = []
        for (let i = 0; i < habs.length; i++) {

            if (habs[i].imgs && habs[i].imgs.length > 0) {
                for (let j = 0; j < habs[i].imgs.length; j++) {
                    let obj = {...habs[i], img: habs[i].imgs[j]};
                    arr.push(obj)
                }
            } else {
                let obj = {...habs[i], img: defecto};
                arr.push(obj)
            }

        }


        console.log(arr)
        setHabitaciones(arr)

    }

    useEffect(() => {

        let datos = props.getValues()
        if (open) {
            setSeConsulto(false)
            setHabitaciones([])
            obtenerHabitacionesDisponibles({
                fechaCheckIn: datos.fechaCheckIn,
                fechaCheckOut: datos.fechaCheckOut
            }).then((dox) => {
                ordenarHabitaciones(dox)
                setSeConsulto(true)
            })
        }


    }, [props.watch('fechaCheckOut', 'fechaCheckIn')]);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{mt: 0}}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', p: 2, zIndex: 2}}>
                <IconButton
                    onClick={() => cerrar()} sx={{backgroundColor: theme.palette.primary.main}}>
                    <Close sx={{fill: '#fff'}}/>
                </IconButton>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -9, zIndex: 1}}>

                {habitaciones.length > 0 ?


                    <Splide
                        ref={refe}
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            // autoplay: true,
                            speed: 1500,
                            rewind: true,
                            perPage: 1,
                            arrows: true,
                            pagination: false,
                            width: '100%',
                            drag: 'false',
                            interval: 5000,
                            noDrag: true,
                            type: 'fade',

                        }}
                    >

                        {habitaciones.map((it, index) => {
                            return (
                                <SplideSlide key={`qe${index}`}>
                                    <Tarjeta_Imagen_Reserva item={it}/>
                                </SplideSlide>
                            )
                        })}


                    </Splide>

                    :

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{py: 8}}
                    >


                        {seConsulto ?

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', px: 6, py: 4}}>
                                <Typography sx={{textAlign: 'center'}}>
                                    No tenemos cabañas disponibles para estos dias, intenta con otras fechas
                                </Typography>
                            </Grid>

                            :
                            <>
                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <CircularProgress/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <Typography>
                                        Consultando Disponibilidad
                                    </Typography>
                                </Grid>
                            </>

                        }


                    </Grid>

                }


            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{p: 3}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Formulario_Reserva_Datos props={props}/>
                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2, mb: 4}}>
                <Button
                    onClick={() => subirReserva()}
                    variant={'contained'} color={'primary'}>Realizar Reserva</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Reserva

const imgs = [
    {
        nombre: 'Cabaña Uno',
        descripcion: 'Casa de Uno',
        img: foto1,
    },
    {
        nombre: 'Cabaña Dos',
        descripcion: 'Casa de Dos',
        img: foto2,
    },
    {
        nombre: 'Cabaña Tres',
        descripcion: 'Casa de Uno',
        img: foto3,
    },
    {
        nombre: 'Cabaña Cuatro',
        descripcion: 'Casa de Uno',
        img: foto4,
    },


]